import { defineStore } from 'pinia'
import axios from 'axios'
import { useStorage } from '@vueuse/core'
import { useLoadingStore } from "@/store/loading";
import { user_company, localStorageKeyPrefix } from "@/constants";

export const useDashboardStore = defineStore('dashboard',{
  state: () => {
    return {
      last_update: useStorage(localStorageKeyPrefix + 'last_update', null),
      items: useStorage(localStorageKeyPrefix + 'items', [
          {
                id: '1',
                name: 'Card 1',
                placement: [2,1],
                report_id: "aaa",
                order: 0,
                chart_options: {
                  legend_position: 'top',
                  show_legend: false,
                  type: 2,
                }
          },
          {
                id: '2',
                name: 'Card 2',
                placement: [1,1],
                report_id: "bbb",
                order: 1,
                chart_options: {
                  legend_position: 'top',
                  show_legend: false,
                  type: 2,
                }
          },
          {
                id: '3',
                name: 'Card 3',
                placement: [1,1],
                report_id: "ccc",
                order: 2,
                chart_options: {
                  legend_position: 'top',
                  show_legend: false,
                  type: 2,
                }
          },
      ]),
    }
  },
  getters: {
    allItems: state => state.items,
    lastUpdate: state => state.last_update,
    item: (state) => (index) => state.items[index],
    findItemByReportId: (state) => (report_id) => state.items.find(item => item.report_id === report_id),
    findItemByItemId: (state) => (item_id) => state.items.find(item => item.id === item_id),
  },
  actions: {
    // Get list of all cards in Dashboard
    async getDashboard() {
      useLoadingStore().setLoading(true)
      const id = user_company
      const thisStore = this
      return await axios.get('/companies/' + id + '/dashboards').then(function (response) {
        if(response.status === 200){
          thisStore.setDashboard(response.data)
          thisStore.updateLastUpdate()
          // commit('setLoading', false)
          return response.data
        }
      })
    },
    async saveCard(data) {
      const loadingStore = useLoadingStore()
      const company_id = user_company
      const card_id = data.id
      let position = [...data.placement, data.order]
      const output = {
        name: data.name,
        position: JSON.stringify(position),
        report_id: data.report_id,
        chart_options: JSON.stringify(data.chart_options ? data.chart_options : {})
      }
      loadingStore.setLoading(true)
      if(data.remove){
        // deleting card
        return await axios.delete(`/dashboards/${card_id}`).then((res) => {
          loadingStore.setLoading(false)
          return res
        })

      } else if(data.id.includes('new-')) {
        // creating new card
        return await axios.post(`/companies/${company_id}/dashboards`, output).then((res) => {
          loadingStore.setLoading(false)
          return res
        })

      } else {
        // editing card
        return await axios.put(`/dashboards/${card_id}`, output).then((res) => {
          loadingStore.setLoading(false)
          return res
        })
      }
    },
    async saveDashboard(){
      if (this.items.length){
        let promises = [];
        const thisStore = this
        for (let item of this.items) {
          const newPromise = function() {
            return new Promise((resolve) => {
              thisStore.saveCard(item).then((response) => {
                resolve(response)
              })
            })
          }
          promises.push(newPromise())
        }
        if(promises.length){
          return await Promise.all(promises).catch(error => {
            error;
          });
        }
      }
    },
    changeOrder(data) {
      function swap(arr, fromIndex, toIndex) {
        let output = arr
        const element = output[fromIndex];
        output[fromIndex] = output[toIndex]
        output[toIndex] = element
        return output
      }
      if (data.oldIndex != data.newIndex) {
        const swapArray = swap(this.items, data.oldIndex, data.newIndex)
        this.items = swapArray.map((item, index) => {
          item.order = index
          return item
        })
      }
    },
    changeSize(data) {
      let index = this.items.findIndex(card => card.id === data.id)
      let item = this.items[index]
      item.placement = data.size
      this.items.splice(index, 1, item)
    },
    setDashboard(data) {
      const parsed = data.map(item=>{
        if(item.position){
          const position = JSON.parse(item.position)
          item.order = position[2]
          item.placement = position.splice(0, 2)
        }
        item.chart_options = item.chart_options ? JSON.parse(item.chart_options) : {}
        item.remove = false
        delete item.position
        return item
      })
      this.items = parsed.sort((a, b) => a.order - b.order)
    },
    setCard(data) {
      let cardData = {
        name: data.output.name,
        report_id: data.output.report_id,
        remove: data.output.remove,
        chart_options: data.output.chart_options
      }
      if(data.edit){
        //edit card
        const index = this.items.findIndex(card => card.id == data.output.id)
        if(index != -1){
          if (cardData.remove && data.output.id.includes('new-')) {
            this.items.splice(index,1)
          } else {
            cardData.id = data.output.id
            cardData.order = data.output.order
            cardData.placement = data.output.placement
            cardData.name = data.output.name
            this.items.splice(index, 1, cardData)
          }
        }
      } else {
        // add new card
        cardData.placement = [1,1]
        cardData.id = 'new-' + Date.now()
        cardData.order = this.items.length
        this.items.push(cardData)
      }
    },
    updateLastUpdate () {
      this.last_update = new Date()
    },
  },
  strict: false,
})
